import { FC } from 'react';
import { TableBody as Body } from '@mui/material';
import dayjs from 'dayjs';

import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';
import { CustomTableRow, RowTableCell } from '../../../../shared/uiComponents/Table/tableHelpers';
import { TableNoData } from '../../../../shared/uiComponents';
import { AdminTypes } from '../../../../components/Menu';

import { BehaviorReductionProperties } from '../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { useSelector } from '../../../../redux/store';
import Details from './Actions/details';

export interface BehaviorRowRendererProperties {
	data: BehaviorReductionProperties[];
}

export const behaviorHeaders: HeaderProperties[] = [
	{ id: '5', name: 'Behavior name' },
	{ id: '1', name: 'Date created' },
	{ id: '2', name: 'Behavior type' },
	{ id: '3', name: 'Behavior Category' },
	{ id: '4', name: '', width: '150px' },
];

export const behaviorHeadersBT: HeaderProperties[] = [
	{ id: '4', name: 'Behavior name' },
	{ id: '1', name: 'Date created' },
	{ id: '2', name: 'Behavior type' },
	{ id: '3', name: 'Behavior Category' },
];

export const BehaviorTableBody: FC<BehaviorRowRendererProperties> = ({ data }) => {
	const role = useSelector((state) => state.account.role);

	if (!data?.length) {
		return <TableNoData spanScope={behaviorHeaders.length} />;
	}

	return (
		<Body>
			{data.map((row, index) => (
				<CustomTableRow key={row.id} style={{ cursor: 'pointer' }}>
					<RowTableCell>{row.name}</RowTableCell>
					<RowTableCell>{dayjs(row.createdAt).format('MM/DD/YYYY')}</RowTableCell>
					<RowTableCell>{row.recordingType.text}</RowTableCell>
					<RowTableCell>{row.category.name}</RowTableCell>
					{role && role.section.id !== AdminTypes.bt && (
						<RowTableCell style={{ display: 'flex', gap: 16, justifyContent: 'flex-end' }}>
							<Details data={row} allBehaviors={data} currentIndex={index} />
						</RowTableCell>
					)}
				</CustomTableRow>
			))}
		</Body>
	);
};
